module.exports = __webpack_public_path__ + "img/世界各国数据.ff588a13.png";